import { API } from "@/App";
import { Download } from "lucide-react";

const DRIVERS = [
  { id: "soft-smile", label: "Soft smile" },
  { id: "gentle-nod", label: "Gentle nod" },
  { id: "look-to-camera", label: "Look to camera" },
  { id: "raised-brows", label: "Raised brows" },
  { id: "calm-blink", label: "Calm blink" },
  { id: "laugh", label: "Laugh" },
  { id: "surprise", label: "Surprise" },
  { id: "sad", label: "Sad / emotional" },
];

export const DriverLibrary = ({ color }) => (
  <div className="demo-card bg-[#0e1013] border border-[#2a2f3d] p-5 space-y-4" data-testid="recast-driver-library">
    <div>
      <h3 className="font-display uppercase text-base" style={{ color }}>Driver library</h3>
      <p className="text-sm text-[#9ba3b4] leading-relaxed mt-1">
        Eight ready-made driver clips for Retarget mode: five calm ones and three expressive ones (laugh, surprise, sad). Each one starts facing the camera and passes Check driver. Pick one in the plugin's
        Driver library menu, or download it here. AI actors, no real people.
      </p>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {DRIVERS.map((d) => (
        <div key={d.id} className="space-y-2" data-testid={`recast-driver-${d.id}`}>
          <video src={`${API}/media/recast-driver-${d.id}.mp4`} muted loop autoPlay playsInline className="w-full aspect-square object-cover bg-black" data-testid={`recast-driver-${d.id}-video`} />
          <a href={`${API}/media/recast-driver-${d.id}.mp4`} download={`recast-driver-${d.id}.mp4`}
             className="flex items-center justify-between gap-2 text-xs uppercase border border-[#2a2f3d] px-2 py-1.5 transition-colors hover:border-current"
             style={{ color }} data-testid={`recast-driver-${d.id}-download`}>
            {d.label} <Download size={12} />
          </a>
        </div>
      ))}
    </div>
  </div>
);
